/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mandatory_Tech_SkillsInputs */

const en_mandatory_tech_skills = /** @type {(inputs: Mandatory_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandatory Tech Skills`)
};

const de_mandatory_tech_skills = /** @type {(inputs: Mandatory_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obligatorische Tech-Skills`)
};

/**
* | output |
* | --- |
* | "Mandatory Tech Skills" |
*
* @param {Mandatory_Tech_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mandatory_tech_skills = /** @type {((inputs?: Mandatory_Tech_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mandatory_Tech_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mandatory_tech_skills(inputs)
	return en_mandatory_tech_skills(inputs)
});